module.exports = __webpack_public_path__ + "front/img/home-kv.e85ad929.png";